import { isAlwaysAbleToBeSetAsDefaultType } from '../../../../reducers/helpers/ewallet.reducer.helper';
export var showAddToBlocklist = function showAddToBlocklist(paymentMethod) {
  return Boolean(!paymentMethod.Blocklisted && !paymentMethod.Allowlisted && paymentMethod.actionables.canBlocklist && !paymentMethod.Locked);
};
export var showRemoveFromBlocklist = function showRemoveFromBlocklist(paymentMethod) {
  return Boolean(paymentMethod.Blocklisted && paymentMethod.actionables.canBlocklist && !paymentMethod.Locked);
};
export var showAddToAllowlist = function showAddToAllowlist(paymentMethod) {
  return Boolean(!paymentMethod.Allowlisted && !paymentMethod.Blocklisted && paymentMethod.actionables.canBlocklist && !paymentMethod.Locked);
};
export var showRemoveFromAllowlist = function showRemoveFromAllowlist(paymentMethod) {
  return Boolean(paymentMethod.Allowlisted && paymentMethod.actionables.canBlocklist && !paymentMethod.Locked);
};
export var paymentInstrumentCanBeSetAsDefault = function paymentInstrumentCanBeSetAsDefault(paymentMethod) {
  return Boolean(paymentMethod && (isAlwaysAbleToBeSetAsDefaultType(paymentMethod.Type) || paymentMethod.actionables.canOrder));
};